<template>
	<div class="d-flex align-center">
    <span class="description d-flex">
      <span>{{ dataItem.setting_key.slice(5) }}:</span>
      <input-editor
		      class="edit-line"
		      v-if="edit"
		      :item="dataItem"
		      :key-value="'setting_value'"
		      :readonly="!permissions['9']"
		      type="text"
      />
      <span v-else class="ml-2">{{ dataItem.setting_value }}</span>
    </span>

		<v-btn class="ml-auto" v-if="permissions['9']" @click="editItem" x-small icon :color="color">
			<v-icon v-if="!edit"> mdi-pencil</v-icon>
			<v-icon v-else> close</v-icon>
		</v-btn>
	</div>
</template>
<script>
import InputEditor from "./input/input.component";

export default {
	components: {
		InputEditor,
	},
	props: {
		dataItem: {
			setting_key: String,
			setting_value: String
		},
		color: String,
		saveMarker: Boolean
	},
	data() {
		return {
			edit: false,
		};
	},
	computed: {
		permissions() {
			return this.$store.getters.permissions;
		},
	},
	methods: {
		editItem() {
			this.edit = !this.edit;
		},
		removeItem(item) {
			console.info(item);
		},
	},
	watch: {
		saveMarker(val) {
			if (val) this.edit = false;
		}
	},
};
</script>
<style lang="scss" scoped>
@import "./editor.component";
</style>
